export const getNamePrefix = (firstname, lastname) => {
  if (!firstname || !lastname) {
    return '';
  }

  const name = `${firstname.substring(0, 1)}${lastname.substring(0, 1)}`;
  return name.toUpperCase();
};

export const getSessionPrefix = name => {
  if (!name) {
    return '';
  }

  const prefix = `${name.substring(0, 1)}`;
  return prefix.toUpperCase();
};

export const getTestNamePrefix = name => {
  if (!name) {
    return '';
  }
  const splitted = name.split(' ');
  const prefix = splitted
    .map(s => s.substring(0, 1))
    .join('')
    .substring(0, 3);
  return prefix.toUpperCase();
};
